/* eslint-disable */
/**
 * Add a script tag to the page
 * @export
 * @param {{ async: boolean, src: string }} options The params to add the script
 * @returns {void} void
 */
const httpAddScript = ({ async, src } = { async: true }) => {
  const script = document.createElement(`script`);
  script.async = async;
  script.type = `text/javascript`;
  script.src = src;
  document.body.appendChild(script);
};

export default httpAddScript;
